import { FC } from "react"

export const VueIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg width="37" height="35" viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="37" height="35" rx="4" fill="#F7F7F7" />
      <path d="M20.9281 8.47656L18.5 12.6438L16.0719 8.47656H8L18.5 26.5234L29 8.47656H20.9281Z" fill="#D0D0D0" />
      <path
        d="M20.9283 8.47656L18.5002 12.6438L16.0721 8.47656H12.2002L18.5002 19.3047L24.8002 8.47656H20.9283Z"
        fill="#979797"
      />
    </svg>
  )
}

